import React, { useState } from 'react';
import Payment from 'payment';
import { UseFormReturn } from 'react-hook-form';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../../../CommonComponents/OPL/Text/Text';
import { Icon } from '../../../../../CommonComponents/OPL/Icon/Icon';
import { Input } from '../../../../../CommonComponents/OPL/Input/Input';
import { Grid } from '../../../../../CommonComponents/OPL/Grid/Grid';
import { Row } from '../../../../../CommonComponents/OPL/Grid/Row';
import { Column } from '../../../../../CommonComponents/OPL/Grid/Column';
import { formatExpiration } from './helpers';
import { CreditCards } from '../../../../types';
import { Tooltip } from '../../../../../CommonComponents/OPL/Tooltip/Tooltip';
import { Wrapper, WrapperProps } from '../../../../../CommonComponents/OPL/Wrapper/Wrapper';
import getImagePath from '../../../../../CommonUtils/getImagePath';

export interface CreditCardFields {
  cardNumber: string;
  securityCode: string;
  expiration: string;
}

interface CreditCardProps extends WrapperProps {
  formBag: UseFormReturn<CreditCardFields>;
}

export const CreditCard: React.FC<CreditCardProps> = ({
  formBag: {
    register,
    setValue,
    formState: { errors },
  },
  ...rest
}) => {
  const [issuer, setIssuer] = useState('');

  return (
    <Wrapper {...rest}>
      <Box display="flex" alignItems="center" mt="16">
        <Text fontWeight={600}>Credit Card</Text>

        {Object.values(CreditCards).map(value => (
          <img
            key={value}
            src={getImagePath(`payment/${value}.jpg`)}
            alt={value}
            css={`
              height: 24px;
              opacity: ${issuer === value ? 1 : 0.3};
              margin-left: 8px;
            `}
          />
        ))}
      </Box>

      <Grid>
        <Row mt="16">
          <Column width={6}>
            <Input
              {...register('cardNumber')}
              label="Card Number"
              type="tel"
              placeholder="Card Number"
              formVariant={errors.cardNumber ? 'error' : undefined}
              helperText={errors.cardNumber ? errors.cardNumber.message : ''}
              onChange={e => {
                setIssuer(Payment.fns.cardType(e.target.value));

                setValue('cardNumber', Payment.fns.formatCardNumber(e.target.value));
              }}
              autoComplete="cc-number"
            />
          </Column>
        </Row>

        <Row mt="16">
          <Column width={2}>
            <Box position="relative">
              <Input
                {...register('securityCode')}
                label="CVV"
                type="tel"
                placeholder="CVV"
                maxLength={4}
                formVariant={errors.securityCode ? 'error' : undefined}
                helperText={errors.securityCode ? errors.securityCode.message : ''}
                autoComplete="cc-csc"
              />

              <Box position="absolute" top={1} left={30}>
                <Tooltip
                  content="CVV is the last 3 digits on the back of your credit card"
                  placement="bottom-start"
                  zIndex={17000}
                >
                  <Icon className="far fa-info-circle" />
                </Tooltip>
              </Box>
            </Box>
          </Column>

          <Column width={2}>
            <Input
              {...register('expiration')}
              label="Expiry Date"
              type="tel"
              placeholder="MM/YY"
              formVariant={errors.expiration ? 'error' : undefined}
              helperText={errors.expiration ? errors.expiration.message : ''}
              onChange={e => {
                setValue('expiration', formatExpiration(e.target.value));
              }}
              autoComplete="cc-exp"
            />
          </Column>
        </Row>
      </Grid>
    </Wrapper>
  );
};
